import { render, staticRenderFns } from "./ListReport.vue?vue&type=template&id=2aaba413"
import script from "./ListReport.vue?vue&type=script&lang=js"
export * from "./ListReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports